import { AbstractControl, ValidationErrors, ValidatorFn, FormGroup } from '@angular/forms';

export function minimumResponsibleValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control || !(control instanceof FormGroup)) {
      return null;
    }

    const formGroup = control as FormGroup;
    const birthDateControl = formGroup.get('basicData.usuDtNascimento');
    const responsiblesControl = formGroup.get('responsibles');

    if (!birthDateControl || !responsiblesControl) {
      return null;
    }

    const birthDate = birthDateControl.value;
    const responsibles = responsiblesControl.value;

    if (!birthDate) {
      return null;
    }

    const age = calculateAge(birthDate);
    if (age < 18 && (!responsibles || responsibles.length === 0)) {
      return { noResponsibleForMinor: true };
    }

    return null;
  };
}

function calculateAge(birthDate: string): number {
  const birth = new Date(birthDate);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDifference = today.getMonth() - birth.getMonth();
  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age;
}
